import UserGuard from "../authGaurd/useUser";
export const withUserAuthGuard = (Component) => (props) => (

    <UserGuard>
        <Component {...props} />
    </UserGuard>
);
